import React, { useState } from "react";
import {
  electricityProperties,
  waterProperties,
  gasProperties,
} from "./BillInfoProperties";
import { useMediaQuery } from "react-responsive";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls, url } from "../../Utils/url";
import { ReactComponent as Tick } from "../../assets/icons/tick.svg";
import { ReactComponent as Alert } from "../../assets/icons/alert.svg";

const BillWarn =
  "کاربر گرامی پرداخت پیش از اتمام مهلت پرداخت مهم است و واریز پس از این تاریخ ممکن است به عنوان بستانکاری در قبوض بعدی محاسبه شود و در قبض بعدی به عنوان بدهی قبلی درج شود";

export function PayBill(
  billId,
  token,
  setBtnActive,
  checked,
  companyId,
  windowVar
) {
  const body = {
    bill_id: billId,
    reminder: checked && (companyId === 4 || companyId === 5) ? 1 : 0,
  };
  ApiCall("post", `${urls.Payment}`, body, "payBill", token, function (e) {
    const link = `${url}Payment/${e.data.invoice_number}`;
    windowVar.location = link;
  });
}

const CompanyImage = (companyId) => {
  switch (companyId) {
    case 1:
      return require("../../assets/images/Water.png");
    case 2:
      return require("../../assets/images/Gas.png");
    case 3:
      return require("../../assets/images/Electricity.png");
    case 4:
      return require("../../assets/images/MCI.png");
    case 5:
      return require("../../assets/images/Telephone.png");
    default:
      break;
  }
};

const Table = ({ TableData, Info }) => {
  return (
    <table>
      {TableData.map((i, index) => (
        <tr>
          <span>{Info[i.value]}</span>
          <span>{i.title}</span>
        </tr>
      ))}
    </table>
  );
};

const BillInfo = ({ name, amount }) => {
  return (
    <div>
      <span>{amount}</span>
      <span>{name}</span>
    </div>
  );
};

const BillInformation = ({
  billId,
  billName,
  companyId,
  amount,
  date,
  info,
  token,
  billParam,
  setBtnActive,
  payId,
  paymentType,
  paymentStatus,
  period,
  paymentParam,
}) => {
  const TableData =
    companyId === 1
      ? waterProperties
      : companyId === 2
      ? gasProperties
      : electricityProperties;
  const [checked, setChecked] = useState(true);
  return (
    <div
      className="BillInformation"
      style={{ justifyContent: paymentType == "SMS" && "flex-start" }}
    >
      {/* <h1>{`${header.replace("پرداخت ", "")}`}</h1> */}
      <div id="Billhistory">
        {!paymentType == "SMS" && (
          <BillInfo
            name={
              companyId == 4
                ? "شماره تلفن همراه:"
                : companyId == 5
                ? "شماره تلفن ثابت:"
                : "نام مشترک:"
            }
            amount={companyId == 4 || companyId == 5 ? billParam : billName}
          />
        )}
        {period !== null && !paymentType == "SMS" && (
          <BillInfo
            name={"نوع قبض:"}
            amount={period === 1 ? "پایان دوره" : "میان دوره"}
          />
        )}

        <BillInfo
          name={companyId == 2 ? "شماره اشتراک:" : "شناسه قبض:"}
          amount={billId}
        />

        <BillInfo name={"شناسه پرداخت:"} amount={paymentParam} />
        <BillInfo name={"مبلغ:"} amount={` ${amount.toLocaleString()} ریال `} />
        {date && !paymentType == "SMS" && (
          <BillInfo name={"مهلت پرداخت:"} amount={date} />
        )}
      </div>
      <img
        src={CompanyImage(companyId)}
        id="companyImage"
        alt=""
        style={{ marginBottom: window.innerHeight * 0.05 }}
      />
      {paymentType == "SMS" && (
        <h3>در صورت تایید مبلغ، دکمه پرداخت را بزنید</h3>
      )}
      {(companyId === 4 || companyId === 5) && !paymentType == "SMS" && (
        <>
          <div className="Reminder" onClick={() => setChecked(!checked)}>
            <span>صدور قبض های بعدی را به من یادآوری کن</span>
            <div>{checked && <Tick />}</div>
          </div>
          <h3>
            با انتخاب گزینه بالا، صدور قبض جدید در ماه های آینده بدون هزینه به
            شما اطلاع رسانی خواهد شد
          </h3>
        </>
      )}
      {(companyId === 1 || companyId === 2 || companyId === 3) &&
        !paymentType == "SMS" && (
          <div className="Warn">
            <Alert />
            <span>{BillWarn}</span>
          </div>
        )}
      {(companyId === 1 || companyId === 2 || companyId === 3) &&
        !paymentType == "SMS" && (
          <>
            {/* <h2>جزئیات قبض</h2> */}
            <Table TableData={TableData} Info={info} />
          </>
        )}
      {paymentStatus === 1 ? (
        <h2>قبض مورد نظر پرداخت شده است!</h2>
      ) : (
        <div
          // type="submit"
          className={"PayButton"}
          // value="پرداخت"
          onClick={() => {
            var windowVar = window.open();
            // window.open("https://www.google.com", "_blank");
            PayBill(payId, token, setBtnActive, checked, companyId, windowVar);
          }}
        >
          پرداخت
        </div>
      )}
    </div>
  );
};

export default BillInformation;
